import React, { Component } from 'react';
import { AppContext } from './../AppContext';
import { Table, Input, Button } from 'reactstrap';
import { Col, Row, Badge } from 'reactstrap';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { withRouter } from 'react-router-dom';
/*import history from "../history";*/
import './NavMenu.css';
import Paginacion from './Paginacion';
import ActividadCard from './ActividadCard';
import url from "./variables/url.js";

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;

export class ActExtracurricular extends Component {
    static displayName = ActExtracurricular.name;

    constructor(props) {
        super(props);
        this.state = {
            status: 0,
            loading: true,
            total: 0,                        
            categorias: [],
            tipos: [],
            currentUser: [],
            actividades: [],
            currentActividades: [], currentPage: null, totalPages: null,           
            
        };

        this.handleEdit = this.handleEdit.bind(this);
    }

    componentDidMount() {
        let user = this.context;
        this.setState({ currentUser: user });
        //console.log(this.state.currentUser.idpersona);
        this.populateInfoData();
        this.populateActividades();        
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.actividades.length !== this.state.actividades.length) {
            this.populateActividades();
        }
    }

    onPageChanged = data => {
        const { actividades } = this.state;
        const { currentPage, totalPages, pageLimit } = data;
        const offset = (currentPage - 1) * pageLimit;
        const currentActividades = actividades.slice(offset, offset + pageLimit);

        this.setState({ currentPage, currentActividades, totalPages });
    }    
    

    renderActividadesTable(actividades, currentActividades, currentPage, totalPages) {
      /*const { currentActividades, currentPage, totalPages } = this.state;*/
      const totalAct = actividades.length;        
      const limite = 4;
      const vecindario = 1;

      return (
      <div>
            <h1>Mis Actividades Extracurriculares</h1>

            <div className="container mb-5">
                <div className="row d-flex flex-row">
                    <div className="w-100 px-4 d-flex flex-row flex-wrap align-items-center justify-content-between">
                        <div className="d-flex flex-row align-items-center">
                              <h2>
                                  <strong className="text-secondary">{totalAct}</strong> Actividades
                            </h2>
                            {currentPage && (
                                <span className="current-page d-inline-block h-100 pl-4 text-secondary">
                                    Page <span className="font-weight-bold">{currentPage}</span> / <span className="font-weight-bold">{totalPages}</span>
                                </span>
                            )}
                        </div>
                          <div className="d-flex flex-row py-4 align-items-center">
                              <Paginacion totalRecords={totalAct} pageLimit={limite} pageNeighbours={vecindario} onPageChanged={this.onPageChanged} />
                        </div>
                    </div>                      
                      {currentActividades.map(act =>
                          <div className="col-3">
                              <ActividadCard actividad={act} />
                              <Badge color="primary">Ingresado</Badge>
                                  &nbsp;&nbsp;|&nbsp;&nbsp;
                               <Button color="primary" onClick={(id) => this.handleEdit(act.idaexregistroactividad)}><FaEdit /></Button>
                                  &nbsp;&nbsp;|&nbsp;&nbsp;
                              <Button color="secondary"><FaTrashAlt /></Button>
                          </div>
                          )}
                </div>
              </div>

              
      </div>
    );
    }

    render() {
        const currentuser = this.context;
        //let contents = this.state.loading
        //    ? <p><em>Loading...</em></p>
        //    : this.renderActividadesTable(this.state.actividades, this.state.currentActividades, this.state.currentPage, this.state.totalPages);

        //let contents2 = this.state.loading
        //    ? <p><em>Loading...</em></p>
        //    : this.renderActividadesTable2(this.state.actividades2, this.state.currentActividades2, this.state.currentPage2, this.state.totalPages2);

        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderActividadesTable(this.state.actividades, this.state.currentActividades, this.state.currentPage, this.state.totalPages);

        return (
            <div>                
                {contents}                
            </div>
        );
    }

    populateActividades() {
        const user = this.context;        

        //console.log(localBack + '/api/RegistroActividad/GetActByCat/' + user.idpersona + '/' + 1);

        fetch(localBack + '/api/RegistroActividad/GetActByCat/' + user.idpersona + '/' + 1, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status,  });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loading: false, total: 1 });
                    //console.log(this.state.actividades);
                } else {
                    this.setState({ actividades: [] });
                }
            });
        
        /*this.setState({ actividades: insig.objDatos, loading: false });*/
    }    

    populateInfoData() {
        fetch(localBack + '/api/Insignia', {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
                .then(data => {
                    //console.log(data);
                    this.setState({
                        categorias: data.objDatos  });
                });

        fetch(localBack + '/api/TipoActividad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                this.setState({
                    tipos: data.objDatos                    
                });
            });        
        
    }

    newAct() {
        //console.log('Nueva Actividad');
        this.props.history.push('/Add-Act');
    }

    handleEdit(id) {
        //console.log("Editar " + id);
        this.props.history.replace("/Edit-Act/" + id);
    }
}
ActExtracurricular.contextType = AppContext;
export default withRouter(ActExtracurricular);